module.exports = __webpack_public_path__ + "static/img/my1.a66cfc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my1.png
// module id = F3Pz
// module chunks = 110